import Button from '../../components/Button';

const FALLBACK_HEADLINE = 'Your Reliable Partner for Wholesale Distribution';
const FALLBACK_SUBHEADLINE =
  'Nation Wholesale LLC connects Amazon FBA sellers and businesses with premium wholesale products — complete with LOA, compliant invoices, and verified supply chain support.';
const FALLBACK_BADGE = 'Trusted Wholesale Distributor USA';
const FALLBACK_STATS = [
  { value: '500+', label: 'Active Sellers' },
  { value: '7+', label: 'Years of Experience' },
  { value: '50K+', label: 'Products Shipped' },
  { value: '100%', label: 'Client Satisfaction' },
];

/**
 * Wraps the last two words of a headline in <em> for accent coloring,
 * unless the headline already contains HTML markup.
 */
function accentLastTwoWords(text) {
  if (!text || text.includes('<')) {
    return <span dangerouslySetInnerHTML={{ __html: text || FALLBACK_HEADLINE }} />;
  }
  const words = text.trim().split(/\s+/);
  if (words.length <= 2) {
    return <em>{text}</em>;
  }
  const normal = words.slice(0, words.length - 2).join(' ');
  const accented = words.slice(words.length - 2).join(' ');
  return (
    <>
      {normal} <em>{accented}</em>
    </>
  );
}

function HeroSection({ settings }) {
  const hero = settings?.hero || {};
  const stats = settings?.hero_stats || FALLBACK_STATS;

  const badge = hero.badge_text || FALLBACK_BADGE;
  const headline = hero.headline || FALLBACK_HEADLINE;
  const subheadline = hero.subheadline || FALLBACK_SUBHEADLINE;
  const primaryLabel = hero.cta_primary_label || 'Apply for Wholesale';
  const secondaryLabel = hero.cta_secondary_label || 'How It Works';

  return (
    <section className="hero" id="home">
      <div className="hero-inner">
        <div>
          <div className="hero-badge">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <circle cx="6" cy="6" r="6" fill="#E8A020" />
            </svg>
            {badge}
          </div>
          <h1>{accentLastTwoWords(headline)}</h1>
          <p>{subheadline}</p>
          <div className="hero-actions">
            <Button variant="primary" to="/wholesale">
              {primaryLabel}
            </Button>
            <Button variant="outline" href="#how">
              {secondaryLabel}
            </Button>
          </div>
        </div>

        <div>
          <div className="hero-stats">
            {(stats.length > 0 ? stats : FALLBACK_STATS).map((stat, i) => (
              <div className="stat-box" key={i}>
                <span className="stat-num">{stat.value}</span>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
